// "$.OtherInvolved" → "Other Involved", "$.Suspects[2]" → "Suspects",
// "$.GeneralInformation" → "General Information", "$" → "General".
// Falls back to the raw path for anything that doesn't fit the simple
// "$.<Key>" shape.
export function prettifySectionPath(path: string): string {
  if (path === "$") return "General";
  const m = /^\$\.([A-Za-z_][A-Za-z0-9_]*)/.exec(path);
  if (!m) return path;
  return m[1]
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}
